const initState = {
  consultas: [],
  activa: -1,
};

const consultaDinamicaReducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_CONSULTAS_DINAMICAS':
      return {
        ...state,
        consultas: action.payload
      };
    case 'SET_ACTIVE_CONSULTA':
      return {
        ...state,
        activa: action.payload
      };
    default:
      return state;
  }
};

export default consultaDinamicaReducer;
